import * as React from 'react'
import getLocation, {
  setLocation2storage,
  setSelectedCity2storage,
  sendTeaLocationEvent,
} from 'lib/get-location'
import { sendTeaCommEvent } from 'lib/tea-analyze'
import { GlobalStoreContext } from 'Components/store'
import City from './new-city'
import Search from './new-search'
import User from './new-user'
import HeaderSwitch from './new-header-switch'
import TopTips from './top-tops-dynamic'
import useHasTips from 'Components/hooks/use-top-tips'
import useFireFox from 'Components/hooks/use-firefox'
import classNames from 'classnames'
import dynamic from 'next/dynamic'
const FixNavModal = dynamic(() => import('New/side-nav/fix-nav'), {
  ssr: false,
})
import ToolTip from 'Components/new/tool-tip'
import usePageOffset from 'Components/hooks/use-page-offset'
import useWindowLoaded from 'Components/hooks/use-window-loaded'
import { useStickHeader } from 'Components/new/scroll-sticky/sticky-header'
import useSideNavStatus, {
  setPageType,
} from 'Components/hooks/use-side-nav-status'
import HeaderLogo from 'Components/new/header-logo'
import { getPageId } from 'lib/page-enter'
import { useRouter } from 'next/router'
import style from './new-header.module.scss'
import { useEffect, useRef, useState } from 'react'
import useHeaderTheme from 'Components/hooks/use-header-theme'
import Cookies from '@arsenal/arsenal/modules/Cookies'

export const headerHeight = 'tw-h-56 lg:tw-h-64 xl:tw-h-78'
export const headerTop = 'tw-top-56 lg:tw-top-64 xl:tw-top-78'

const AddToDesktop: React.FC<{
  className: string
}> = React.memo(({ className }) => {
  const isLoaded = useWindowLoaded()
  const [visible, setVisible] = useState(false)
  const promptEventRef = useRef<any>()
  useEffect(() => {
    if (!isLoaded) {
      return
    }
    if ('serviceWorker' in navigator) {
      navigator.serviceWorker
        .register('/sw.js', { scope: '/' })
        .then(function () {
          console.log('ServiceWorker registration success')
        })
        .catch(function () {
          console.log('ServiceWorker registration failed')
        })
    }
    const handlePrompt = (event: any) => {
      promptEventRef.current = event
      setVisible(true)
      event.userChoice.then((choiceResult: any) => {
        if (choiceResult.outcome === 'accepted') {
          setVisible(false)
          sendTeaCommEvent('clk_event', {
            event_id: 'install',
            button_name: '安装',
            uid: Cookies('tt_webid'),
          })
          localStorage.setItem('pwa_installed', '1')
        } else {
          // dismissed
        }
      })
      const isPWAInstalled = localStorage.getItem('pwa_installed')
      sendTeaCommEvent('show_event', {
        event_id: 'add_desk',
        uid: Cookies('tt_webid'),
        state_type: isPWAInstalled ? '1' : '0',
      })
    }
    window.addEventListener('beforeinstallprompt', handlePrompt)
    return () => {
      window.removeEventListener('beforeinstallprompt', handlePrompt)
    }
  }, [isLoaded])

  return visible ? (
    <ToolTip
      className={className}
      tag="div"
      theme="light"
      arrowVisible={false}
      content={({ close }) => (
        <div className="tw-px-16 tw-py-24 tw-text-center">
          <img
            src={require('static/add-desktop.jpg')}
            alt=""
            width={456}
            height={240}
            style={{ width: 228, height: 120 }}
          />
          <div className="tw-leading-24 tw-text-16 tw-font-semibold tw-mt-12">
            添加懂车帝到桌面
          </div>
          <div className="tw-leading-22 tw-mt-6 tw-text-color-gray-800">
            下次可从电脑桌面直接访问懂车帝
          </div>
          <button
            type="button"
            className="tw-w-full tw-h-36 tw-rounded-2 tw-bg-common-yellow hover:tw-bg-common-highlight-yellow tw-mt-24"
            onClick={() => {
              promptEventRef.current!.prompt()
              close()
              sendTeaCommEvent('clk_event', {
                event_id: 'add_desk_module_btn',
                button_name: '立即添加',
                uid: Cookies('tt_webid'),
              })
            }}
          >
            立即添加
          </button>
        </div>
      )}
      onTipShow={() => {
        sendTeaCommEvent('show_event', {
          event_id: 'add_desk_module',
          uid: Cookies('tt_webid'),
        })
      }}
    >
      <i className={`DCD_Icon icon_fail ${style['add-icon']}`} />
      <span
        className={style['dch-text']}
        onMouseOver={() => {
          sendTeaCommEvent('show_event', {
            event_id: 'hover',
            uid: Cookies('tt_webid'),
          })
        }}
      >
        添加到桌面
      </span>
    </ToolTip>
  ) : null
})

const DcdPublish: React.FC<{
  className: string
}> = React.memo(({ className }) => {
  const list = [
    {
      text: '文章',
      href: 'https://mp.dcdapp.com/profile_v2/publish/article',
    },
    { text: '视频', href: 'https://mp.dcdapp.com/profile_v2/publish/video' },
    {
      text: '懂车分',
      href: 'https://mp.dcdapp.com/profile_v2/publish/car-score/recommend',
    },
    { text: '车友圈动态', href: 'https://mp.dcdapp.com/ugc/publish#/post' },
  ]
  return (
    <ToolTip
      theme="light"
      arrowVisible={false}
      placement="bottom-start"
      content={({ close }) => (
        <div>
          {list.map((item, index) => {
            return (
              <a
                className={style['publish-item']}
                target={'_blank'}
                href={item.href}
                rel="nofollow"
                key={index}
                onClick={() => {
                  close()
                  sendTeaCommEvent('clk_event', {
                    event_id: 'common_top_btn',
                    obj_id: item.text,
                  })
                }}
              >
                {item.text}
              </a>
            )
          })}
        </div>
      )}
    >
      <a
        className={className}
        target={'_blank'}
        rel="nofollow"
        href="https://mp.dcdapp.com/profile_v2/publish/article"
        onClick={() => {
          sendTeaCommEvent('clk_event', {
            event_id: 'common_top_btn',
          })
        }}
      >
        <i className={`DCD_Icon icon_dongchehao-PC ${style['dch-icon']}`} />
        <span className={style['dch-text']}>发布作品</span>
      </a>
    </ToolTip>
  )
})

function Header({ pageType = 'new' }: { pageType?: string }) {
  const isHasTips = useHasTips()
  const isFireFox = useFireFox()
  const isLoaded = useWindowLoaded()
  const router = useRouter()

  // 防止ssr与前端渲染的html不一致的问题，在服务端不渲染城市
  const { state, dispatch } = React.useContext(GlobalStoreContext)
  const { cityName } = state

  const { isFixed, duration } = useStickHeader()

  React.useEffect(() => {
    if (typeof state.cityName === 'undefined') {
      try {
        const cityName = window.localStorage.getItem('cityName')
        // 优先从本地存储中获取城市
        if (cityName) {
          dispatch({
            type: 'setCityName',
            payload: cityName || '',
          })
          sendTeaLocationEvent('init_top_location')
        } else {
          // 获取不到时，调用location获取
          getLocation().then((location) => {
            setLocation2storage(location)
            dispatch({
              type: 'setCityName',
              payload: location.cityName || '',
            })
            sendTeaLocationEvent('init_top_location')
          })
        }
      } catch (err) {}
    }
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [state.cityName])
  const headerTheme = useHeaderTheme()

  const themeClassName = React.useMemo(() => {
    return {
      'tw-text-common-black hover:tw-text-common-red':
        headerTheme === 'default',
      'tw-text-video-shallow-gray hover:tw-text-white':
        headerTheme === 'theater',
    }
  }, [isFixed, headerTheme])

  // 关闭tooltip
  const closeCityRef = React.useRef<() => void>()
  const closeCodeRef = React.useRef<() => void>()

  React.useEffect(() => {
    if (isFixed) {
      if (closeCityRef.current) {
        closeCityRef.current()
      }
      if (closeCodeRef.current) {
        closeCodeRef.current()
      }
    }
  }, [isFixed])

  const { top } = usePageOffset()

  useEffect(() => {
    setPageType(pageType)
  }, [pageType])

  const navStatus = useSideNavStatus()

  return (
    <header
      className={classNames(style['header'], 'header', headerHeight, {
        [style['fire-fox']]: isFireFox,
      })}
      style={{ paddingTop: top }}
    >
      <div
        className={classNames(
          `header-fix clearfix`,
          headerHeight,
          style['header-fix'],
          headerTheme,
          {
            'tw-pl-88': navStatus === 'off',
            'tw-pl-160': navStatus === 'on',
            'tw-pl-88 lg:tw-pl-160': navStatus === 'md-off',
            'tw-pl-88 xl:tw-pl-160': navStatus === 'lg-off',
            'lg:tw-pl-160': navStatus === 'md-none',
          }
        )}
        style={{ top }}
      >
        <div className={style['switch-wrap']}>
          <HeaderSwitch pageType={pageType} />
        </div>
        <div
          style={
            {
              paddingRight: '4%',
              '--duration': `${duration}ms`,
            } as React.CSSProperties
          }
          className={classNames(
            'tw-h-full tw-flex tw-items-center tw-justify-between',
            {
              [style.leave]: isFixed && duration,
              [style.enter]: !isFixed && duration,
            }
          )}
        >
          <div
            className={classNames(
              'tw-flex tw-items-center tw-transform tw-ml-72',
              {
                'tw--translate-x-88': navStatus === 'off',
                'tw--translate-x-160': navStatus === 'on',
                'tw--translate-x-88 lg:tw--translate-x-160':
                  navStatus === 'md-off',
                'tw--translate-x-88 xl:tw--translate-x-160':
                  navStatus === 'lg-off',
                'lg:tw--translate-x-160': navStatus === 'md-none',
              }
            )}
          >
            <HeaderLogo />
            {cityName ? (
              <ToolTip
                theme={'light'}
                placement={'bottom-start'}
                arrowVisible={false}
                tag={'div'}
                content={({ close }) => {
                  closeCityRef.current = close
                  return (
                    <City
                      onChange={(name) => {
                        setSelectedCity2storage(name!)
                        sendTeaLocationEvent('switch_top_location', name)
                        close()
                      }}
                    />
                  )
                }}
                className={style['city']}
              >
                {(showTips) => (
                  <button
                    type={'button'}
                    className={classNames(
                      'tw-py-8 tw-whitespace-nowrap',
                      themeClassName
                    )}
                    onMouseEnter={(event) => {
                      event.stopPropagation()
                      event.nativeEvent.stopImmediatePropagation()
                      sendTeaCommEvent('hover_event', {
                        event_id: 'common_city_select_btn',
                        shrink_type: 'unfold',
                      })
                    }}
                    onMouseLeave={(event) => {
                      event.stopPropagation()
                      event.nativeEvent.stopImmediatePropagation()
                      sendTeaCommEvent('hover_event', {
                        event_id: 'common_city_select_btn',
                        shrink_type: 'fold',
                      })
                    }}
                    onClick={(event) => {
                      event.stopPropagation()
                    }}
                  >
                    {cityName}
                    <span
                      className={classNames('DCD_Icon tw-text-14 tw-ml-4', {
                        icon_triangle_down_12: !showTips,
                        icon_triangle_up_12: showTips,
                      })}
                    />
                  </button>
                )}
              </ToolTip>
            ) : null}
          </div>
          <Search
            isFixed={isFixed}
            className={classNames({
              'tw--translate-x-44': navStatus === 'off',
              'tw--translate-x-80': navStatus === 'on',
              'tw--translate-x-44 lg:tw--translate-x-80':
                navStatus === 'md-off',
              'tw--translate-x-44 xl:tw--translate-x-80':
                navStatus === 'lg-off',
              'lg:tw--translate-x-80': navStatus === 'md-none',
            })}
          />
          <div className="tw-flex tw-items-center tw-whitespace-nowrap">
            <AddToDesktop
              className={`${style['dch-link']} ${themeClassName} tw-ml-6 md:tw-ml-0`}
            />
            {getPageId(router?.asPath) !== 'page_quality_qa_detail' && (
              <a
                target={'_blank'}
                rel="nofollow"
                className="download tw-mr-30 md:tw-mr-40"
                href="https://www.dcdapp.com/download/"
                onClick={() => {
                  sendTeaCommEvent('clk_event', {
                    event_id: 'common_top_btn',
                  })
                }}
                onMouseEnter={(event) => {
                  sendTeaCommEvent('hover_event', {
                    event_id: 'common_download_app_btn',
                    button_name: '下载App',
                  })
                }}
              >
                <ToolTip
                  tag={'button'}
                  theme={'light'}
                  arrowVisible={false}
                  className={classNames('tw-leading-20', themeClassName)}
                  content={({ close }) => {
                    closeCodeRef.current = close
                    return (
                      <div className={style['vrcode-container']}>
                        <h3 className="tw-pt-16">扫码下载懂车帝App</h3>
                        <img
                          src={require('static/dcd-code@3x.png')}
                          alt="懂车帝app"
                          className={style['vrcode']}
                        />
                      </div>
                    )
                  }}
                >
                  <i className="code-icon tw-inline-block tw-w-14 tw-h-14 xl:tw-w-18 xl:tw-h-18 xl:tw-mr-4 tw-align-middle" />
                  <span className={style['dch-text']}>下载App</span>
                </ToolTip>
              </a>
            )}
            <DcdPublish className={`${style['dch-link']} ${themeClassName}`} />
            <User isFixed={isFixed} />
          </div>
        </div>
      </div>
      {isLoaded ? <FixNavModal pageType={pageType} /> : null}
      {isHasTips && isLoaded ? <TopTips /> : null}
      <style jsx>
        {`
          .code-icon {
            background: url(${require('static/code-icon-bg.png')}) center/cover;
          }
          .download:hover .code-icon {
            background-image: url(${require('static/code-icon-bg-active.png')});
          }
          :global(.header-fix.theater .code-icon) {
            background-image: url(${require('static/black-code-icon.png')});
          }
          :global(.header-fix.theater .download:hover .code-icon) {
            background-image: url(${require('static/hover-black-code-icon.png')});
          }
          :global(.header-fix.theater .side-nav-switch) {
            background: url(${require('static/black-icon-switch-btn.png')})
              no-repeat 0 0 / cover;
          }
        `}
      </style>
    </header>
  )
}

export default Header
